

<template>
    <svg :width="size" :height="size" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.6667 16.0693C13.3267 16.0693 15.3334 14.0626 15.3334 11.4026C15.3334 8.74263 13.3267 6.73596 10.6667 6.73596C8.00675 6.73596 6.00008 8.74263 6.00008 11.4026C6.00008 14.0626 8.00675 16.0693 10.6667 16.0693ZM12.0001 17.3333H9.33342C5.65741 17.3333 2.66675 20.324 2.66675 24V25.3333H18.6667V24C18.6667 20.324 15.6761 17.3333 12.0001 17.3333ZM27.0588 11.056L21.3254 16.7786L19.6027 15.056L17.7174 16.9413L21.3254 20.5466L28.9414 12.944L27.0588 11.056Z" fill="currentColor"/>
</svg>
  </template>
  
  <script>
  export default {
    props: {
      size: { type: String }
    }
  }
  </script>